import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Router, Switch } from "react-router-dom";
import { refreshToken, logout } from "./Actions/api";
import { clearMessage, clearResponse } from "./Actions/message";
import { history } from "./Helpers/history";
import { I18nProvider, LOCALES } from "./i18n";
import NotFoundPage from "./LandingPage/404";
import ChangePassword from "./LandingPage/Account/ChangePassword";
import ForgetPassword from "./LandingPage/Account/ForgetPassword";
import SignIn from "./LandingPage/Account/Login";
import Profile from "./LandingPage/Account/Profile";
import SignUp from "./LandingPage/Account/Register";
import ResetPassword from "./LandingPage/Account/ResetPassword";
import Contact from "./LandingPage/Account/Contact";
// import Referral from './LandingPage/Referral';
import API from "./LandingPage/API";
import APIProduct from "./LandingPage/API/Product";
import Faq from "./LandingPage/Faq";
import Home from "./LandingPage/Home";
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';

const Routes = () => {
  const dispatch = useDispatch();
  const { isLoggedIn, isUniqueLogin } = useSelector((state) => state.auth);
  const [language, setLanguage] = useState(LOCALES.ENGLISH);
  const [concurrentLogin, setConcurrentLogin] = useState(false);
  const SecretRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? <Component {...props} /> : history.push("/Login")
      }
    />
  );
  const { confirm } = Modal;

  function pushLogin() {
    dispatch(logout());
    history.push("/Login");
  }

  useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = false;
    const test = (e) => {
      dispatch(clearMessage());
      dispatch(clearResponse());
    };
    history.listen((location) => {
      test();
    });
    var aValue = localStorage.getItem("Language");
    if (aValue === "ENGLISH") {
      setLanguage(LOCALES.ENGLISH);
    } else if (aValue === "CHINESE") {
      setLanguage(LOCALES.CHINESE);
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  useEffect(() => {
    if(isUniqueLogin === false && !concurrentLogin){
      setConcurrentLogin(true);
      confirm({
        title: 'Session Alert',
        icon: <ExclamationCircleOutlined />,
        content: `Looks like you are logged into multiple devices at the same time. For security reasons, we have ended all sessions. Please try to login again later.`,
        async onOk() {
          pushLogin();
        },
        cancelButtonProps:{ style: { display: 'none' } }
      });
    }
  }, [isUniqueLogin])

  return (
    <I18nProvider locale={language}>
      <Router history={history}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/Home" component={Home} />
          <Route exact path="/APIs" component={API} />
          <SecretRoute
            exact
            path="/APIs/:Market/:APIProductCategory"
            component={APIProduct}
          />
          <Route exact path="/Faq" component={Faq} />
          <Route exact path="/SignUp" component={SignUp} />
          <Route exact path="/Login" component={SignIn} />
          <Route exact path="/ForgetPassword" component={ForgetPassword} />
          <Route exact path="/Contact" component={Contact} />
          <Route
            exact
            path="/ResetPassword:email?/:code?"
            component={ResetPassword}
          />
          <SecretRoute exact path="/Profile" component={Profile} />
          <SecretRoute
            exact
            path="/ChangePassword"
            component={ChangePassword}
          />
          <Route path="*">
            <NotFoundPage />
          </Route>
        </Switch>
      </Router>
    </I18nProvider>
  );
};

export default Routes;
